import Barba from "barba.js";
import Hammer from 'hammerjs';

export default class VideoCarousel {

    constructor(element) {
        this.row = element;
        this.__setup()
    }

    __updateMovement() {
        if (matchMedia('(min-width: 1440px)').matches) {
            this.movement = 20;
            this.maxElements = 5
        } else if (matchMedia('(min-width: 768px)').matches) {
            this.movement = 100 / 3;
            this.maxElements = 3
        } else {
            this.movement = 50;
            this.maxElements = 2
        }
    }

    __setup() {
        this.__updateMovement();
        if (matchMedia('(min-width: 768px)').matches) {
            this.currentPosition = this.movement
        } else {
            this.currentPosition = 0
        }
        this.controllers = this.row.querySelectorAll('.row-controls .controller');
        this.mask = this.row.querySelector('.video-mask');
        this.header = this.row.querySelector('.video-row-header');
        this.carousel = this.row.querySelector('.video-items');
        this.items = this.carousel.querySelectorAll('.video-item')

        this.controllers.forEach(el => {
            if (el.classList.contains('next')) return el.addEventListener('click', this.__next.bind(this))
            return el.addEventListener('click', this.__prev.bind(this))
        })

        let gesture = new Hammer( this.carousel );
        gesture.on('swipe', this.__swipe.bind(this) );

        this.items.forEach(el => {
            el.addEventListener('click', this.__clickHandler.bind(this))
        })
    }

    __swipe(ev) {
        if( Math.sign( ev.deltaX ) > 0 ) {
            this.__prev()
        } else {
            this.__next()
        }
    }

    __next() {
        this.__updateMovement();
        if (-1 * this.currentPosition >= (this.items.length - this.maxElements) * Math.round(this.movement * 10) / 10) return;
        this.carousel.style.transform = 'translateX(' + this.__position(1) + '%)';
    }

    __prev() {
        this.__updateMovement();
        if( matchMedia('(max-width: 768px)').matches && this.currentPosition >= 0) return;
        if (this.currentPosition >= Math.round(this.movement * 10) / 10) return;
        this.carousel.style.transform = 'translateX(' + this.__position(-1) + '%)';
    }

    __position(direction = 1) {
        this.__updateMovement();
        this.currentPosition -= direction * this.movement;
        return this.currentPosition = Math.round(this.currentPosition * 10) / 10
    }

    __clickHandler(event) {
        event.preventDefault();
        Barba.Pjax.Manager.getAnimationManager().get('videoModal').play(event.currentTarget);
    }

    destroy() {
        console.log('i was destroyed')
    }

}